import { userRoutes } from 'modules/user/routes/constants';

export const trainingsCertificatesRoutes = {
  root: `${userRoutes.root}/certificates`,
};
